import {
  LegalReportTemplate,
  type TemplateConfig,
  LegalReportType
} from '~/types/legalReports/main'
import { TagTheme } from '~/types/tagTheme'

export const CUSTOM_REPORT_TEMPLATE_CONFIG = {
  [LegalReportType.CUSTOM_REPORT]: {
    title: 'legalReports.customReport.title',
    description: 'legalReports.customReport.description',
    companySize: '👤 All',
    tagTheme: TagTheme.PRIMARY
  }
} as const satisfies { [key in LegalReportTemplate]?: TemplateConfig }
